<template>
  <div class="login-container flex">
    <div class="left">
      <div>
        <div class="a-box">
          <a @click="this.$router.push('/')">
            <img src="../assets/home/logon-icon-01.png" alt="" />
            返回首页</a
          >
        </div>
        <div class="text1">欢迎您登录</div>
        <div class="text2">阳泉高新技术产业开发区</div>
        <div class="text3">企业公共服务平台</div>
      </div>
    </div>
    <div class="right">
      <img
        class="logo"
        @click="this.$router.push('/')"
        src="../assets/home/logo.png"
        alt=""
      />
      <div class="login_cont">
        <a-form
          class="login-form"
          ref="ruleForm"
          layout="vertical"
          :model="form"
          :rules="rules"
          @submit="onSubmit"
        >
          <div class="tabs-box">
            <div
              class="tab-item"
              :class="activeKey == '1' ? 'tab-active' : ''"
              @click="tabsChange('1')"
            >
              企业用户
            </div>
            <div
              class="tab-item"
              :class="activeKey == '2' ? 'tab-active' : ''"
              @click="tabsChange('2')"
            >
              其他用户
            </div>
          </div>
          <div v-show="activeKey == '1'">
            <a-form-item name="username">
              <a-input
                size="large"
                v-model:value="form.username"
                placeholder="请输入统一社会信用代码"
              >
                <template #prefix>
                  <user-outlined class="tc-gray" />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item name="password">
              <a-input-password
                size="large"
                v-model:value="form.password"
                placeholder="请输入密码"
              >
                <template #prefix>
                  <lock-outlined class="tc-gray" />
                </template>
              </a-input-password>
            </a-form-item>
          </div>
          <div v-show="activeKey == '2'">
            <a-form-item name="username">
              <a-input
                size="large"
                v-model:value="form.username"
                placeholder="请输入注册手机号"
              >
                <template #prefix>
                  <user-outlined class="tc-gray" />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item name="password">
              <a-input-password
                size="large"
                v-model:value="form.password"
                placeholder="请输入密码"
              >
                <template #prefix>
                  <lock-outlined class="tc-gray" />
                </template>
              </a-input-password>
            </a-form-item>
          </div>
          <a-row :gutter="[10, 24]">
            <a-col :span="16">
              <!--                            <Vcode :show="isShow" @success="success" @close="close" @fail='fail'></Vcode>-->
              <Verify
                @success="success"
                :captchaType="'blockPuzzle'"
                :imgSize="{ width: '330px', height: '155px' }"
                ref="verify"
              />
            </a-col>
          </a-row>
          <div style="margin-top: 20px">
            <a-button
              size="large"
              type="primary"
              html-type="submit"
              block
              :loading="confirmLoading"
              @click="onSubmit"
            >
              立即登录
            </a-button>
            <div style="overflow: hidden; margin-top: 10px">
              <p style="float: left">
                <a @click="goMore('/forgetPass', activeKey)"> 忘记密码</a>
              </p>
              <p style="float: right">
                还没有账户？请<a
                  @click="goMore('/register', isReview ? 'review' : 'user')"
                >
                  注册</a
                >
              </p>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import {platformName} from "@/config/platformConfig";
import dataCheck from "@/utils/dataCheck";
import {login_mp, sys_admin, file_service} from "@/api/adminService";
// import { companyInfo } from '@/api/companyService';
// import {getAction} from "@/utils/http/service";
// import axios from "axios";
import {notification} from "ant-design-vue";
import Vcode from "vue3-puzzle-vcode";
import Verify from '../components/verifition/Verify'
export default {
    name: "login",
    components: {
      Verify,
        Vcode
    },
    data() {
        const checkUsername = (rule, value, callback) => {
            const reg1 =
                /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/;
            const reg2 =
                /^1[0-9]{10,10}$/;
            if (this.activeKey === '1') {
                if (value === '') {
                    callback(new Error("请输入统一社会信用代码"))
                } else if (!reg1.test(value)) {
                    callback(new Error("请输入正确的统一社会信用代码"))
                } else {
                    callback();
                }
            } else {
                if (value === '') {
                    callback(new Error("请输入注册手机号"))
                } else if (!reg2.test(value)) {
                    callback(new Error("请输入正确的注册手机号"))
                } else {
                    callback();
                }
            }
            console.log(rule, 'rule')
            console.log(value, 'value')
            console.log(callback, 'value')
        }
        return {
            activeKey: '1',
            all_logo: '',
            code: '',
            codeLength: 4,
            inputvalue: '',
            show: false,
            showerror: false,
            platformName,
            confirmLoading: false,
            loginType: 'manage',
            form: {
                username: null,
                password: null,
                // captcha: null,
            },
            isReview: false,
            rules: {
                // username: [
                //     dataCheck.required({ msg: '账号不能为空' }),
                // ],
                username: {validator: checkUsername, trigger: 'blur'},
                password: [
                    dataCheck.required({msg: '密码不能为空'}),
                ],
                // captcha: [
                //     dataCheck.required({msg: '验证码不能为空'}),
                // ],
            },
            captchaPath: '',
            redirectPath: this.$ls.get("redirectPath_ls"),
            isShow: false,
        }
    },

    mounted() {
        this.loginType = this.$route.query.id
        if (this.$route.query.type === 'review') {
            this.isReview = true
        }
        if (this.$route.query.redirect) {
            this.redirectPath = this.$route.query.redirect;

            this.$notification.warning({
                message: '提示',
                description: '请登录后继续',
            })
        }
        if (this.$ls.get('token')) {
            this.$router.push(this.redirectPath);
            return false;
        }
        // this.setCaptchaPath();
        this.createCode();
        this.all_logo = this.$ls.get('all_logo');
    },
    methods: {
        tabsChange(e){
            this.activeKey = e
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        goMore(url, str) {
            this.$router.push({path: url, query: {id: str}})
        },
        createCode() {
            const codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f',
                'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
                'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
                'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');
            for (var i = 0; i < this.codeLength; i++) {
                var charNum = Math.floor(Math.random() * 62);
                this.code += codeChars[charNum];
            }
        },
        clearCode() {
            this.code = '';
            this.createCode()
        },
        heckCode() {
            var inputCode = this.inputvalue;
            if (inputCode.length <= 0) {
                this.show = true
                this.showerror = false
            } else if (inputCode.toUpperCase() != this.code.toUpperCase()) {

                this.showerror = true
                this.show = false
                this.code = ''
                this.createCode();
                // this.inputvalue = "";
            } else {
                this.showerror = false
                this.show = false
            }
        },
        // 用户通过了验证
        success(msg) {
            this.isShow = false; // 通过验证后，需要手动隐藏模态框
            console.log('验证通过' + msg);
            this.goSuccess()
        },
        // 用户点击遮罩层，应该关闭模态框
        close() {
            this.isShow = false;
        },
        // 用户验证失败
        fail() {
            console.log('验证失败');
        },
        onSubmit() {
            // this.heckCode();
          this.$refs.verify.show();
            this.isShow = true;
        },
        goSuccess() {
          let VerifyToken=this.$ls.get('captchaVerification')||''
            if (this.showerror == false && this.show == false) {
                this.$refs.ruleForm
                    .validate()
                    .then((values) => {
                        this.confirmLoading = true;
                        // this.isShow = true;
                        this.postAction({
                                url: login_mp.login,
                                params: {
                                    password: values.password,
                                    username: values.username,
                                    grant_type: 'password',
                                    client_id: 'sc.smartpark',
                                    client_secret: 'secret',
                                    loginType: this.loginType,
                                    VerifyToken

                                },
                                isValid: false
                            }
                        ).then((res) => {
                            console.log('报401', res)
                            this.postAction({
                                url: login_mp.saveLog,
                                params: {logAppCategoryEnum: "LOGIN"}
                            }).then(res => {
                                console.log(res, 'res')
                            })
                            // console.log(res,'res')

                            this.$ls.set('token', res.data.access_token, 1000 * 60 * 60 * 5);
                            this.$ls.set('refresh_token', res.data.refresh_token);
                            this.confirmLoading = false;
                            if (res.data.code == 503) {
                                notification.error({
                                    message: res.data.result,
                                    style: {
                                        width: '400px',
                                        fontWeight: '600',
                                    }
                                });
                            } else {
                              
                              
                                this.getAction({
                                    url: sys_admin.userInfor
                                }).then(res => {
                                    this.$ls.set("userInfo", res.userName)
                                    this.$ls.set("companyCode", res.companyCode)
                                    this.$ls.set("companyName", res.companyName)
                                    this.$ls.set("phoneNumber", res.phoneNumber)
                                    this.$ls.set("notificationId", res.id)
                                    this.$ls.set("roleCode", res.roleCode)
                                    this.$ls.set("serviceOrganizationId", res.serviceOrganizationId)
                                    this.$ls.set('userName', res.userName, 1000 * 60 * 60 * 5);
                                    setTimeout(() => {
                                        location.reload()
                                    }, 5);
                                    if (this.$route.query.gourl == 'jf') {
                                        this.$router.push('/sys/manage');
                                        this.$ls.set('redirectPath_ls', '/sys/manage')
                                    } else if (this.$route.query.gourl == 'seal') {
                                        this.$router.push('/sys/EnterpriseSealService')
                                        this.$ls.set('redirectPath_ls', '/sys/EnterpriseSealService')
                                    } else if (res.roleCode.includes('company')) {
                                        this.$router.push('/sys/userIndex')
                                        this.$ls.set('redirectPath_ls', '/sys/companyInfo')
                                    } else if (res.roleCode.includes('technicalManager')) {
                                        this.$router.push('/sys/technology/person');
                                        this.$ls.set('redirectPath_ls', '/sys/technology/person')
                                    } else if (res.roleCode.includes('serviceOrganization')) {
                                        this.$router.push('/sys/innovation/organization/index');
                                        this.$ls.set('redirectPath_ls', '/sys/innovation/organization/index')
                                    } else if (res.roleCode.includes('investorManager')) {
                                        this.$router.push('/finance/investorInformation');
                                        this.$ls.set('redirectPath_ls', '/finance/investorInformation')
                                    } else if (res.roleCode.includes('investmentMechanism')) {
                                        this.$router.push('/finance/investmentOrganizationInformation');
                                        this.$ls.set('redirectPath_ls', '/finance/investmentOrganizationInformation')
                                    } else if (res.roleCode.includes('financialAdviser')) {
                                        this.$router.push('/finance/financialAdvisorInformation');
                                        this.$ls.set('redirectPath_ls', '/finance/financialAdvisorInformation')
                                    } else if (res.roleCode.includes('bank')) {
                                        this.$router.push('/finance/financingInstitutionInformation');
                                        this.$ls.set('redirectPath_ls', '/finance/financingInstitutionInformation')
                                    } else if (res.roleCode.includes('expert')) {
                                        this.$router.push('/sys/userIndex');
                                        this.$ls.set('redirectPath_ls', '/sys/expertInfo')
                                    } else if (res.roleCode.includes('gov-institution')) {
                                        this.$router.push("/sys/govInstitution")
                                        this.$ls.set('redirectPath_ls', '/sys/govInstitution')
                                    } else {
                                        this.$router.push('/sys/userInfo');
                                        this.$ls.set('redirectPath_ls','/sys/userInfo')
                                    }
                                })
                            }
                        }).catch((error) => {
                            notification.error({
                                message: error.response.data.error_description,
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                }
                            });
                            this.confirmLoading = false;
                        })
                    })
                    .catch(() => {
                    })
            }
        }
    },
    beforeCreate() {
        // 修改背景色
        document.querySelector('body').setAttribute('style', 'background-color:#fff')
    },
    beforeUnmount() {
        // 销毁背景色
        document.querySelector('body').removeAttribute('style')
    },
}
</script>

<style scoped lang="less">
a {
  color: #0059b5;
}
.tabs-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  .tab-item {
    font-weight: 400;
    font-size: 20px;
    color: #999999;
    line-height: 16px;
    cursor: pointer;
    border-bottom: 10px solid #fff;
    padding-bottom: 6px;
  }
  .tab-active {
    color: #0059b5;
    font-weight: bold;
    border-bottom: 4px solid #0059b5;
  }
}
.flex {
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  color: #fff;

  .left {
    width: 60%;
    background: url("../assets/home/login-bj.png");
    background-size: cover;
    //margin-right: 100px;
    height: 100vh;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 200px;
    .text1 {
      font-size: 36px;
      font-weight: 500;
      margin: 80px 0 30px 0;
    }
    .text2,
    .text3 {
      font-size: 46px;
      font-weight: 500;
    }
    .a-box {
      width: 124px;
      height: 32px;
      line-height: 32px;
      border-radius: 40px;
      background: #fff;
      padding: 0 10px;
      text-align: center;
      img {
        width: 16px;
        height: 16px;
        margin-bottom: 3px;
      }
      a {
        color: #104460;
        font-size: 16px;
      }
    }
  }
  ::v-deep .ant-btn {
    background: #0059b5;
    border: 1px solid #0059b5;
  }
  .right {
    width: 26%;
    margin: 0 auto;
    .logo {
      width: 100%;
      margin-bottom: 100px;
      cursor: pointer;
    }
  }
}
</style>
